import { request } from './index';
import axios from '@/axios';

export async function getOpos() {
    return await request("GET", "/references/by_type_reference/1")
}

export async function getOpcs() {
    return await request("GET", "/references/by_type_reference/2")
}

export async function getTypeReferences() {
    return await request("GET", "/type_references")
}

export async function getDonorStatus() {
    return await request("GET", "/donor_status")
}
export async function getKindOfDonor() {
    return await request("GET", "/kind_of_donors")
}

export async function getCep(cep) {
    // return await request("GET", "/orgon/filter", {}, { params: { name: '', type_orgon: '', hospital: '' } })
    try {
      const { data } = await axios.get(`/search_api/cep`, { params: {
        number: cep
      }});
        return data.data
    }catch (error){
        return error  
    }
}

export async function getStates() {
    return await request("GET", "/search_api/states")
}
export async function getCountries() {
    return await request("GET", "/search_api/countries")
}

export async function getDiagnosis() {
    return await request("GET", "/initial_diagnosis")
}

export async function getUnities() {
    return await request("GET", "/unities")
}

export async function getProfiles() {
    return await request("GET", "/profiles")
}

export async function getMunicipalities(state) { 
    try {
      const { data } = await axios.get(`/search_api/municipalities`, { params: {
        state: state
      }});
        return data.data
    }catch (error){
        return error  
    }
}
export async function getPatientsData(items, unity) {   
 
    try {
      const { data } = await axios.get(`/donor/filter`, { params: {
        ...items, unity: unity ?? ''
      }});

        return data.data
    }catch (error){
        return error  
    }
}



export default { getOpos, 
    getOpcs, 
    getTypeReferences,
    getDonorStatus, 
    getKindOfDonor, 
    getCep,
    getStates, 
    getCountries, 
    getMunicipalities, 
    getPatientsData, 
    getDiagnosis,
    getUnities,
    getProfiles,
};